import * as React from 'react';

import { GlobalProps } from 'lib/app/global-props';

type Props = {
  children: React.ReactNode;
  value: GlobalProps;
};

export const GlobalPropsContext = React.createContext<GlobalProps>({
  lang: __DEFAULT_LANG__,
  country: __DEFAULT_COUNTRY__,
});

export const GlobalPropsProvider: React.FC<Props> = ({ children, value }) => {
  return <GlobalPropsContext.Provider value={value}>{children}</GlobalPropsContext.Provider>;
};
